import React from "react";
import styled from "styled-components";

const SpinnerStyle = styled.svg`
  @keyframes spinnerSpin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  --fl-spinner-size: 40px;
  animation: spinnerSpin 1s infinite cubic-bezier(0.35, 0.3, 0.3, 0.35);
  height: var(--fl-spinner-size);
  width: var(--fl-spinner-size);
  margin: auto auto ${(props) => props.theme.spacing.medium};
`;

function LoadingSpinner() {
  return (
    <SpinnerStyle
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className="fl-icon-spinner">
      <path
        d="M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-3A5 5 0 1 0 8 3a5 5 0 0 0 0 10z"
        opacity=".3"
      />
      <path d="M8 13a1.5 1.5 0 0 1 0 3A8 8 0 0 1 .323 5.742a1.5 1.5 0 1 1 2.879.846A5 5 0 0 0 8 13z" />
    </SpinnerStyle>
  );
}

export { LoadingSpinner };
